"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchOperateBindAdmin = class extends Mixins(AccountSessionMixins) {
  get show() {
    var _a;
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
      if (item.marks.is("DELETE")) {
        return false;
      }
      if (item.marks.is("SHOP_NOT_ALLOW_DEL")) {
        return false;
      }
    }
    if (this._controller.query.filter.group === "shopgroup_system_recycle" && !((_a = this.$session) == null ? void 0 : _a.marks.any("ALLOW_DELETE_SHOP_IN_RECYCLE"))) {
      return false;
    }
    return true;
  }
  deleteShop() {
    var _a;
    if (this._controller.query.filter.group === "shopgroup_system_recycle" && ((_a = this.$session) == null ? void 0 : _a.marks.any("ALLOW_DELETE_SHOP_IN_RECYCLE"))) {
      this.$emit("batchrealDeleteShop");
    } else {
      this.$emit("deleteShop");
    }
  }
};
__decorateClass([
  PropSync("controller")
], BatchOperateBindAdmin.prototype, "_controller", 2);
BatchOperateBindAdmin = __decorateClass([
  Component
], BatchOperateBindAdmin);
export {
  BatchOperateBindAdmin as default
};
